export default __webpack_public_path__ + "img/0593c6b75f70dafbd69b67e80cd37811.png";